<template>
  <!-- 错误页面 -->

    <el-result icon="warning" title="提示" subTitle="请在微信客户端打开链接">
      
    </el-result>

</template>

<script>
export default {
  name: "errorIndex",
  data() {
    return {
      curPath: '',
      isCreate: false,
      isVoteItem: false,
      isVoteEdit: false,
    }
  },
  mounted() {
    console.log(this.$route.path)

  },
  computed: {
    // setter
    set: function () {
      this.curPath = this.$route.path
    }
  },
  methods: {


  }
}
</script>

<style scoped>
.createItem {
  margin: 0px auto 40px auto;
  text-align: center;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  box-shadow: 0 0 25px #cac6c6;
}

.createItem:hover {
  background-color: #36aaff;
  color: white;
}

.createItemDesc {
  padding: 0px 0px 10px 0px;
}

.active {
  background-color: #36aaff;
  color: white
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vote/errorIndex.vue